import { useQuery } from "react-query";
import { GET } from "../../../../Services";

export const useSelectTipoPokemon = () => {
  return useQuery(
    ["selectTipoPokemon"],
    async () => {
      const response = await GET("pokemon/selectTipoPokemon");
      return response;
    }
  );
};

export const useSelectPokemonOriginal = () => {
  return useQuery(
    ["selectPokemonOriginal"],
    async () => {
      const response = await GET("pokemon/selectPokemon");
      return response;
    }
  );
};

export const useListarPokemonTable = () => {
  return useQuery(
    ["listarPokemonTable"],
    async () => {
      const response = await GET("pokemon/listarPokemonTable");
      return response;
    }
  );
};

